/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { ResumeSection } from './section/section.model';

/**
 * Angular Resume model.
 */
export class Resume {
  id : string;

  /**
   * Email address to display on resume
   */
  emailAddress : string;

  /**
   * Permissions of the resume.
   */
  permissions : Array< any > = new Array< any >();

  /**
   * Facebook social profile to display on resume.
   */
  facebook: string;

  /**
   * Full name to display on resume.
   */
  fullName : string;

  /**
   * Twitter|X to display on resume.
   */
  twitter : string;

  /**
   * Instagram social profile to display on resume.
   */
  instagram : string;

  /**
   * Linkedin social profile to display on resume.
   */
  linkedin: string;

  /**
   * Location to display on resume.
   */
  location : string;

  /**
   * Phone number to display on resume.
   */
  phoneNumber : string;

  /**
   * A list of sections for the Resume. About me, experience, etc.
   */
  sections : Array< ResumeSection > = new Array< ResumeSection >();

  /**
   * Website social profile to display on resume.
   */
  website: string;

  /**
   * Default Constructor.
   */
  constructor() {}
}
